import { useContext, useMemo } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AuthContext } from '@contexts/auth-context';

import publicRoutes from './public';
import protectedRoutes from './protected';
import commonRoutes from './common-routes';

function AppRoutes() {
  const { isLoading, isAuthenticated } = useContext(AuthContext);

  const routes = useMemo(() => {
    // protectedAdminRoutes are included in protectedRoutes, so we don't need to add them here
    return isAuthenticated ? [...protectedRoutes, ...commonRoutes] : [...publicRoutes, ...commonRoutes];
  }, [isAuthenticated]);

  const router = useMemo(() => createBrowserRouter(routes), [routes]);

  if (isLoading) return null;

  return <RouterProvider router={router} />;
}

export default AppRoutes;
